import React, { Component } from "react"
import trans from "trans"

import {
    css,
    InputGroup,
    TextInput,
} from "@bdfx/mergado-ui-kit"

import IconifyForm from "./iconify-form"
import BadgesForm from "./badges-form"

import ShapeType, { BADGE_TYPE, EXTERNAL_IMAGE_SOURCE_TYPE } from "shape-entities/types/shape"
import { SizeType } from "app/types/model-types"
import { FormNameType } from '../../app/types/model-types';
import { ENTER_KEY } from "app/helpers/keymap"

const PREDEFINED_SEARCH_WORDS = ['tag', 'label', 'frame', 'sticker', 'delivery', 'sale', 'discount', 'rectangle', 'circle', 'star', 'badge',
    'mark', 'bubble', 'ticket', 'banner', 'ribbon', 'package', 'box', 'shape', 'summer', 'autumn', 'spring', 'winter', 'easter', 'valentine',
    'christmas', 'emoji', 'arrow', 'heart', 'gift'
]

interface Props {
    formName: FormNameType
    change: Function
    shape: ShapeType
    templateSize: SizeType
}

interface State {
    switchType: 'badges' | 'icons'
    isSearching: boolean
    showWords: boolean
    search: string
}

const PAGE_SIZE = 100

class ExternalImageForm extends Component<Props, State> {
    iconifyFormRef = React.createRef<IconifyForm>()

    constructor(props) {
        super(props)

        this.state = {
            switchType: (props.shape && (props.shape.external_image_prompt || props.shape.custom_set_id) && !props.shape.set_id) ? 'icons' : 'badges',
            isSearching: null,
            showWords: null,
            search: props.shape.external_image_prompt || null,
        }
    }

    componentDidMount(): void {
        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    handleKeyDown = (e) => {
        const { search } = this.state
        if (!e.ctrlKey && e.target.tagName && e.target.tagName === 'INPUT' && e.keyCode === ENTER_KEY && `${e.target.id}`.includes('external_image_prompt')) {
            e.preventDefault()
            this.triggerSearch(search, PAGE_SIZE, 1)
        }
    }

    setSearching = (isSearching: boolean) => this.setState({ isSearching })

    triggerSearch = (search: string, limit: number, start: number) => {
        const { switchType } = this.state

        if (switchType === 'icons') {
            this.iconifyFormRef.current?.searchImage(search, limit, start)
        }
        //badges search is filtered client-side in BadgesForm from the `search` prop, no trigger needed
    }

    toggleSwitch = () => {
        const {switchType} = this.state
        this.setState({ switchType: switchType === 'badges' ? 'icons' : 'badges' })
    }

    render() {
        const { shape, formName } = this.props
        const { switchType, search, isSearching, showWords } = this.state

        const switchOptions = ['badges', 'icons'].map((s) => {
            return {
                value: s,
                label: trans(s),
            }
        })

        return (
            <div style={{ padding: '10px' }}>
                <div style={{ margin: '15px 0' }}>
                    <TextInput
                        type="search"
                        placeholder={trans('search_badges_or_icons')}
                        value={this.state.search}
                        disabled={isSearching}
                        className={isSearching ? 'muk-helper-loading' : ''}
                        onChange={(value) => this.setState({ search: value })}
                        onClear={() => this.setState({search: null})}
                        onClick={() => this.setState({ showWords: true })}
                    />
                </div>

                {showWords &&
                    <StyledWordsDiv style={{ maxWidth: '100%' }}>
                        {PREDEFINED_SEARCH_WORDS.map(text =>
                            <span
                                key={text}
                                className="framed"
                                onClick={() => {
                                    this.props.change(`templateForm.shapes.${shape.index}`, 'external_image_prompt', text)
                                    this.setState({ search: text })
                                    this.triggerSearch(text, PAGE_SIZE, 1)
                                }}>{text}</span>
                        )}
                    </StyledWordsDiv>
                }

                <InputGroup
                    singleChoice={true}
                    hideInput={true}
                    onChange={(value) => {
                        if (value !== this.state.switchType) {
                            //clear on switch:
                            this.props.change(formName, `shapes.${shape.index}`, {
                                ...shape,
                                type: value === 'badges' ? BADGE_TYPE : EXTERNAL_IMAGE_SOURCE_TYPE,
                                set_id: null,
                                set_file_id: null,
                                custom_set_id: null,
                                custom_set_file_id: null,
                                imageBlob: null,
                                set: null,
                                customSet: null,
                                external_image_prompt: value === 'badges' ? null : search,
                            })

                            this.setState({ switchType: value })
                        }
                    }}
                    value={switchType}
                    items={switchOptions}
                    style={{
                        ' .m-radio-wrapper': {
                            margin: '3px',
                        },
                        background: '#f0f1f5',
                        borderRadius: '8px',
                        /* ' .muk-radio.active': {
                            background: '#ffffff',
                        } */
                    }}
                />

                {switchType === 'icons' &&
                    <IconifyForm
                        ref={this.iconifyFormRef}
                        formName={this.props.formName}
                        change={this.props.change}
                        shape={this.props.shape}
                        templateSize={this.props.templateSize}
                        search={search}
                        isSearching={isSearching}
                        setSearching={this.setSearching}
                    />
                }

                {switchType === 'badges' &&
                    <BadgesForm
                        shape={this.props.shape}
                        search={search}
                        isSearching={isSearching}
                        setSearching={this.setSearching}
                        toggleSwitch={this.toggleSwitch}
                    />
                }
            </div>
        )
    }
}

const StyledWordsDiv = css('div')({
    ' .framed': {
        cursor: 'pointer',
        display: 'inline-block',
    },
})

export default ExternalImageForm
